import { Controller } from "@hotwired/stimulus";
import { animate } from "animejs";

export default class extends Controller {
  static targets = ["content"];

  initialize() {
    this.animatedElements = this.element.querySelectorAll(
      ".intro-title, .intro-text p, .intro-image",
    );
  }

  connect() {
    if (document.documentElement.hasAttribute("data-turbo-preview")) {
      this.animatedElements.forEach((e) => {
        e.style.opacity = 0;
      });

      return;
    }

    this.animateReveal();
  }

  animateReveal() {
    animate(this.animatedElements, {
      opacity: [0, 1],
      translateX: ["-10rem", "0"],
      duration: 600,
      delay: (el, i) => i * 100,
      ease: "inOutSine",
    });
  }
}
